export default "__VITE_ASSET__CruL7hHT__"